import {
 FETCH_CITIES_REQUESTED,
 FETCH_CITIES_SUCCEED,
 FETCH_CITIES_FAIL,
} from './actionTypes';

export function fetchCitiesRequested() {
  return {
    type: FETCH_CITIES_REQUESTED,
  };
}

export function fetchCitiesSucceeded(params) {
  return {
    type: FETCH_CITIES_SUCCEED,
    payload: params,
  };
}

export function fetchCitiesFailed(params) {
  return {
    type: FETCH_CITIES_FAIL,
    payload: params,
  };
}



// WEBPACK FOOTER //
// ./src/store/cities/actions.js